module.exports = __webpack_public_path__ + "static/media/auth-header.5c69d0f0.png";